/**
 * In the HorNavBar there are Fund & Period pickers, as well as switchers.
 * These objects are the most frequent, therefore we need a DTO
 * that handles when the given element should appear in the navbar.
 * Each object represented via boolean and is meant to show or not to show.
 */
export class HorNavBarShowElements {
  showOrgFundPicker: boolean;
  periods: boolean;
  numberSwitcher: boolean;
  periodTypeSwitcher: boolean;
  showIrr: boolean;
  showPortfolio: boolean;
  singleOrg: boolean;
  market_analysis: boolean;
  vintagePeriods: boolean;
  adminSwitcher: boolean;
  search: boolean;
  notifications: boolean;
  logoSlider: boolean;
  allPeriodsButton: boolean;
  orcaAiButton: boolean;

  constructor(
    showOrgFundPicker: boolean,
    periods: boolean,
    numberSwitcher: boolean,
    periodTypeSwitcher: boolean,
    showIrr: boolean,
    showPortfolio: boolean,
    singleOrg: boolean,
    marketAnalysis: boolean,
    adminSwitcher: boolean,
    search: boolean,
    notifications: boolean,
    logoSlider: boolean,
    allPeriodsButton: boolean,
    orcaAiButton: boolean,
  ) {
    this.showOrgFundPicker = showOrgFundPicker;
    this.periods = periods;
    this.numberSwitcher = numberSwitcher;
    this.periodTypeSwitcher = periodTypeSwitcher;
    this.showIrr = showIrr;
    this.showPortfolio = showPortfolio;
    this.singleOrg = singleOrg;
    this.market_analysis = marketAnalysis;
    this.adminSwitcher = adminSwitcher;
    this.search = search;
    this.notifications = notifications;
    this.logoSlider = logoSlider;
    this.allPeriodsButton = allPeriodsButton;
    this.orcaAiButton = orcaAiButton;
  }
}

export class HorNavBarShowPicker {
  org = { isShown: false };
  fund = { isShown: false };
  fp = { isShown: false };
  maFp = { isShown: false };
  fs = { isShown: false, deleteMenu: false };
}
